import React from "react";
import { Link } from "react-router-dom";
import gif from "../../../assets/gif.gif";
const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="mvs-bottom-page-wrapper">
      <div className="row">
        <div className="col-12 col-md-9">
          <h4 className="title_text">
            Enhance Precision with Advanced Machine Vision Solutions
          </h4>
          <p className="contact_investers_para">
            At Soori Corporation, we’re more than a provider; we’re your partner
            in innovation. Our machine vision solutions leverage cutting-edge
            technology to improve quality control and efficiency, helping you
            achieve higher standards in production and operations.
          </p>
          <Link
            to="/connect-with-us"
            className="btn-md btn-dark border-0"
            onClick={() => scrollHeader()}
          >
            Discover Precision Solutions Now
          </Link>
        </div>
        <div className="col-12 col-md-3">
          <div className="circle-gif">
            <img src={gif} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
